import { TeamDetails } from '../pages';
import { IPage } from '../pages/types';
import { WithRouteData } from '../render-routes';

export const TeamPage = (props: IPage) => <TeamDetails {...props} />;

export default WithRouteData(TeamPage);
